// Soniox短命APIキー取得サービス
export class SonioxService {

  /**
   * Sonioxの短命APIキーを取得
   * Railsの /api/soniox_tokens を経由して、サーバー側で発行されたキーを取得する
   * @returns {Promise<string|null>} 成功時はトークン、失敗時はnull
   */
  static async fetchAuthToken() {
    try {
      const response = await fetch("/api/soniox_tokens", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (data.token) {
        console.log("[SonioxService] トークン取得成功")
        return data.token
      } else {
        console.error("[SonioxService] トークン取得失敗: tokenが空")
        return null
      }
    } catch (error) {
      console.error("[SonioxService] API呼び出しエラー:", error)
      return null
    }
  }
}
